import { useNavigate } from "react-router-dom";
import { usePlayer } from "@/context/PlayerContext";
import { useAuth } from "@/context/AuthContext";
import { Lock, X, Crown } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PremiumOverlay() {
  const { locked, setLocked } = usePlayer();
  const { isGuest } = useAuth();
  const nav = useNavigate();
  if (!locked) return null;

  return (
    <div data-testid="premium-overlay" className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center p-6">
      <div className="relative bg-card border-2 border-primary max-w-md w-full p-8 block-shadow fade-up">
        <button data-testid="premium-overlay-close" onClick={() => setLocked(false)} className="absolute top-4 right-4 text-muted-foreground hover:text-white">
          <X size={22} />
        </button>
        <Lock className="text-primary mb-4" size={40} />
        <div className="overline text-xs text-accent mb-2">Preview ended</div>
        <h2 className="font-display text-3xl font-bold leading-tight mb-3">THE OPS WANT YOU QUIET.</h2>
        <p className="text-sm text-muted-foreground mb-6">
          Guests only get 25 seconds. Unlock unlimited full-length listening for <span className="text-white font-bold">$5/month</span>. No skips. No cuts. No ops.
        </p>
        <div className="space-y-3">
          <Button data-testid="premium-overlay-subscribe" onClick={() => { setLocked(false); nav(isGuest ? "/register" : "/subscribe"); }} className="w-full bg-primary hover:bg-white hover:text-primary rounded-none font-bold overline text-sm h-12">
            <Crown size={16} className="mr-2" /> Unlock for $5/mo
          </Button>
          {isGuest && (
            <Button data-testid="premium-overlay-login" onClick={() => { setLocked(false); nav("/login"); }} variant="outline" className="w-full rounded-none border-2 overline text-xs font-bold">
              Already got an account? Log in
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
